import type { ApolloClient } from '@apollo/client'

export function useAbstractFindFragment<T>(client: ApolloClient, fragment: MyDocumentNode, fragmentName: string, id: string | None): T | null {
  if (!id) return null
  return client.readFragment<T>({ fragment: TypedDocumentString.getQueryDocument(fragment), fragmentName, id: `${fragmentName}:${id}` }) as T | null
}
